//输入控件
import React, { Component } from 'react';
import { DatePicker, List } from 'antd-mobile';
import { autobind } from 'core-decorators';
import tools from '../utils/tools'
import './TimePickerControl.less'

class TimePickerControl extends Component {

  //构造函数
  constructor(props, context) {
    //写构造方法时  必须实现父类的构造方法  否则构造失败  报错
    super(props, context);
  }
  /*================自定义事件====================*/

  render() {
    const { Name, value ,ReadOnly} = this.props;
    let timeValue = value;
    timeValue = typeof timeValue == 'string' && timeValue != '' ? new Date(timeValue.indexOf('-') > 0 ? timeValue.replace(/\-/g, "/") : `0001-1-1 ${timeValue}`.replace(/\-/g, "/")) : timeValue;
    timeValue = timeValue instanceof Date && tools.formatTime(timeValue) == "" ? "" : timeValue;
    const className = timeValue == '' ? 'icon-rili':'icon-shanchu1';
    const controlClassName =  timeValue == '' ? 'timeControl':'timeControl_selected';
    if(ReadOnly){
      return ( <p data-Name={Name}>{tools.formatTime(timeValue)}</p>)
    }
    console.log('timeValue,',timeValue)
    return (<div className={controlClassName}>
    <DatePicker
          mode= "time"
          use12Hours
          value={timeValue}
          onChange={this.onChange}
          extra="请选择"
        ><List.Item></List.Item>
        </DatePicker>{timeValue && <span onClick={this.clear} className={`icon iconfont ${className} timeIcon`}/>}
    </div>);
  }

  @autobind
  onChange(date) {
    const { onChange } = this.props;
    if (onChange)
     onChange(`${tools.formatTime(date)}:00`)
  }

  clear = ()=>{
    const { onChange } = this.props;
    if (onChange)
      onChange('');
  }
}
export default TimePickerControl;